import PcPlusScreen from "./PcPlusScreen";

export default PcPlusScreen;
